export default "__VITE_ASSET__BGXxyqfz__"